import React, { useState } from "react";
import { Heart } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function HeartButton({ note }) {
  const { user } = useAuth();
  const [hearted, setHearted] = useState(!!note.hearted);
  const [count, setCount] = useState(note.heart_count || 0);
  const [pop, setPop] = useState(false);

  const toggle = async () => {
    if (!user) {
      toast("Log in to leave a heart on a note");
      return;
    }
    setHearted(!hearted);
    setCount((c) => c + (hearted ? -1 : 1));
    if (!hearted) setPop(true);
    try {
      const { data } = await api.post(`/notes/${note.id}/heart`);
      setHearted(data.hearted);
      setCount(data.heart_count);
    } catch (err) {
      setHearted(hearted);
      setCount(note.heart_count || 0);
      toast.error(apiError(err.response?.data?.detail));
    }
  };

  return (
    <button
      data-testid={`note-heart-btn-${note.id}`}
      onClick={toggle}
      aria-pressed={hearted}
      title={hearted ? "Remove your heart" : "This note touched me"}
      className={`flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border transition-colors duration-200 ${
        hearted ? "bg-pink-500/30 border-pink-400/60 text-pink-100" : "bg-black/30 border-pink-500/20 text-slate-300 hover:text-pink-200 hover:border-pink-400/50"
      }`}
    >
      <Heart
        onAnimationEnd={() => setPop(false)}
        className={`w-3.5 h-3.5 transition-transform duration-200 ${pop ? "heart-pop" : ""}`}
        fill={hearted ? "currentColor" : "none"}
      />
      <span data-testid={`note-heart-count-${note.id}`}>{count}</span>
    </button>
  );
}
